namespace TabAurous.Master {
    export interface SalesPersonForm {
        DesignationId: Serenity.LookupEditor;
        EmployeeCode: Serenity.StringEditor;
        EmployeeName: Serenity.StringEditor;
        Details: OMS.TargetMasterEditor;
    }

    export class SalesPersonForm extends Serenity.PrefixedContext {
        static formKey = 'Master.SalesPerson';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalesPersonForm.init)  {
                SalesPersonForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = OMS.TargetMasterEditor;

                Q.initFormType(SalesPersonForm, [
                    'DesignationId', w0,
                    'EmployeeCode', w1,
                    'EmployeeName', w1,
                    'Details', w2
                ]);
            }
        }
    }
}
